/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MonthInputs */

const en_month = /** @type {(inputs: MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`month`)
};

const es_month = /** @type {(inputs: MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mes`)
};

const fr_month = /** @type {(inputs: MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

const de_month = /** @type {(inputs: MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

const id_month = /** @type {(inputs: MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bulan`)
};

/** @type {(inputs: MonthInputs) => LocalizedString} */
const ja_month = en_month;

/** @type {(inputs: MonthInputs) => LocalizedString} */
const zh_month = en_month;

/** @type {(inputs: MonthInputs) => LocalizedString} */
const ar_month = en_month;

/** @type {(inputs: MonthInputs) => LocalizedString} */
const it_month = en_month;

/** @type {(inputs: MonthInputs) => LocalizedString} */
const ru_month = en_month;

/** @type {(inputs: MonthInputs) => LocalizedString} */
const pt_month = en_month;

/** @type {(inputs: MonthInputs) => LocalizedString} */
const ko_month = en_month;

/**
* | output |
* | --- |
* | "month" |
*
* @param {MonthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const month = /** @type {((inputs?: MonthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MonthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_month(inputs)
	if (locale === "es") return es_month(inputs)
	if (locale === "fr") return fr_month(inputs)
	if (locale === "de") return de_month(inputs)
	if (locale === "ja") return ja_month(inputs)
	if (locale === "zh") return zh_month(inputs)
	if (locale === "ar") return ar_month(inputs)
	if (locale === "id") return id_month(inputs)
	if (locale === "it") return it_month(inputs)
	if (locale === "ru") return ru_month(inputs)
	if (locale === "pt") return pt_month(inputs)
	return ko_month(inputs)
});